import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { kandakeOutdoors, productOne, productTwo } from '@/assets/siteMedia'
import { howItWorks } from '@/data/consultations'

export const HowItWorksSection = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader title="How it" accent="works" />
      <ol className="mb-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {howItWorks.map((h, index) => (
          <li key={h.step}>
            <Reveal delay={index * 80} className="h-full">
              <div className="h-full rounded-3xl border border-base-200 bg-base-50 p-6 transition-colors hover:border-green-300">
                <span className="mb-4 block font-display text-4xl leading-none text-gold-500">
                  {h.step}
                </span>
                <h3 className="mb-2 font-display text-xl text-base-900">{h.title}</h3>
                <p className="text-sm leading-6 text-base-600">{h.desc}</p>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>

      <Reveal>
        <div className="grid gap-4 lg:grid-cols-[1.6fr_1fr]">
          <SitePhoto
            src={kandakeOutdoors}
            alt="Kandake selecting fresh medicinal plants"
            aspect="aspect-[16/9]"
          />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-1 lg:grid-rows-2">
            <SitePhoto src={productOne} alt="Prepared botanical remedy" />
            <SitePhoto src={productTwo} alt="Instrumental Health herbal formulation" />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
)
